import { useCallback, useState } from 'react';

type UseJsonObjectViewerStringExpansionArgs = {
  initialExpandedPaths?: string[];
};

export const useJsonObjectViewerStringExpansion = ({
  initialExpandedPaths = [],
}: UseJsonObjectViewerStringExpansionArgs = {}) => {
  const [expandedStringPaths, setExpandedStringPaths] = useState<Set<string>>(
    () => new Set(initialExpandedPaths),
  );

  const isStringExpanded = useCallback(
    (path: string) => expandedStringPaths.has(path),
    [expandedStringPaths],
  );

  const toggleStringExpanded = useCallback((path: string) => {
    setExpandedStringPaths(prev => {
      const next = new Set(prev);
      if (next.has(path)) {
        next.delete(path);
      } else {
        next.add(path);
      }
      return next;
    });
  }, []);

  return {
    isStringExpanded,
    toggleStringExpanded,
    expandedStringPaths,
  };
};
